<script>
	import Light from "./elements/Light.svelte";
	import { isPortraitScreen, pageOffset, toggleUniversalToPageScroll, logoDone } from '../js/model/stores';
	import { freezeElement, animateElement } from '../js/utils/animate';

	let _arrow;
	let done = false;
	let portrait;

	let animation = (value) => {

		animateElement(value, _arrow, (currentPageOffset) => {
			if(done || !$logoDone) {
				return;
			}
			done = true;
			_arrow.style.opacity = 1;
			_arrow.classList.add('arrow--moves');
		});

		freezeElement(value, _arrow, (currentPageOffset) => {
			if(!done || !$logoDone) {
				return;
			}
			_arrow.classList.remove('arrow--moves');
			_arrow.style.opacity = 0;
			done = false;
		});
	};

	let prepareScene = () => {
		if (!_arrow) {
			requestAnimationFrame(prepareScene);
			return;
		}

		_arrow.classList.remove('arrow--moves');

		pageOffset.subscribe(animation);
		logoDone.subscribe(animation);
		isPortraitScreen.subscribe((state) => {
			portrait = state;
		});
	};

	prepareScene();
</script>
<style>

	svg {
		position: absolute;
		top: 21em;
		left: 50%;
		transform: translateX(-50%);
		opacity: 0;
		transition: opacity .5s;
		height: auto;
		width: 13em;
	}

	svg.portrait {
		width: 9em;
		top: 14em;
	}

	.arrow--moves {
		animation: invite 6s infinite linear;
	}

	@keyframes invite {
		0% {
			transform: translateX(-50%) translateY(0);
		}
		5% {
			transform: translateX(-50%) translateY(1em);
		}
		10% {
			transform: translateX(-50%) translateY(0);
		}
		15% {
			transform: translateX(-50%) translateY(1em);
		}
		20% {
			transform: translateX(-50%) translateY(0);
		}
	}
</style>

<svg class:portrait bind:this={_arrow} class="arrow--moves" width="196" height="75" viewBox="0 0 196 75" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M135 0L98 28L61 0H0L98 74.1L196 0H135Z" fill="#EBC851"/>
</svg>
